import React, { useState } from "react";
import './index.css';
import moon from './../assets/destination/image-moon.webp';
import mars from './../assets/destination/image-mars.webp';
import europa from './../assets/destination/image-europa.webp';
import titan from './../assets/destination/image-titan.webp';

const Destination = () => {
    const [imageId, setImageId] = useState(0);

    const destinationImg = [moon, mars, europa, titan];
    
    const changeImageId = (idx) => {
        setImageId(idx);
    };

    const handleClick = (e) => {
        e.preventDefault();
        const target = e.currentTarget;
        const targetTab = target.getAttribute('href').substring(1);
        const targetImage = target.getAttribute('data-image-id');
        //remove active class
        const menu = document.querySelectorAll('.destination-nav .menu-item');
        menu.forEach((el) => {
            el.classList.remove('active');
        });
        // add active class
        target.parentElement.classList.add('active');
        //change destination image
        changeImageId(targetImage);
        // hide all the tabs
        const tabs = document.querySelectorAll('.destination-tabs .tab');
        tabs.forEach((el) => {
            el.classList.remove('show');
        });
        //change destination tab
        document.getElementById(targetTab).classList.add('show');
    }

    return(
        <main className="page destinations">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <h1 className="page-title mb-0">
                            <strong className="page-number">01</strong>
                            Pick your destination
                        </h1>
                        <div className="destination-content">
                            <figure className="destination-figure">
                                <img className="destination-location" src={destinationImg[imageId]} alt="Destination"/>
                            </figure>
                            <div className="destination-wrapper">
                                <ul className="destination-nav menu">
                                    <li className="menu-item active">
                                        <a href="#moon" className="menu-link" data-image-id="0" onClick={handleClick}>Moon</a>
                                    </li>
                                    <li className="menu-item">
                                        <a href="#mars" className="menu-link" data-image-id="1" onClick={handleClick}>Mars</a>
                                    </li>
                                    <li className="menu-item">
                                        <a href="#europa" className="menu-link" data-image-id="2" onClick={handleClick}>Europa</a>
                                    </li>
                                    <li className="menu-item">
                                        <a href="#titan" className="menu-link" data-image-id="3" onClick={handleClick}>Titan</a>
                                    </li>
                                </ul>
                                <div className="destination-tabs">
                                    <div id="moon" className="tab show">
                                        <h2 className="destination-title">Moon</h2>
                                        <p className="destination-desc">See our planet as you've never seen it before. A perfect relaxing trip away to help regain perspective and come back refreshed. While you're there, take in some history by visiting the Luna 2 and Apolo 11 landing sites.</p>
                                        <hr/>
                                        <div className="destination-info">
                                            <div className="destination-distance">
                                                <p className="info-label">Avg. distance</p>
                                                <p className="info-value">384,400 km</p>
                                            </div>
                                            <div className="destination-time">
                                                <p className="info-label">Est. travel time</p>
                                                <p className="info-value">3 days</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="mars" className="tab">
                                    <h2 className="destination-title">Mars</h2>
                                        <p className="destination-desc">Don't forget to pack your hiking boots. You'll need them to tackle Olympus Mons, the tallest planetary mountain in our solar system. It's two and a half times the size of Everest!</p>
                                        <hr/>
                                        <div className="destination-info">
                                            <div className="destination-distance">
                                                <p className="info-label">Avg. distance</p>
                                                <p className="info-value">225 mil. km</p>
                                            </div>
                                            <div className="destination-time">
                                                <p className="info-label">Est. travel time</p>
                                                <p className="info-value">9 months</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="europa" className="tab">
                                    <h2 className="destination-title">Europa</h2>
                                        <p className="destination-desc">The smallest of the four Galilean moons orbiting Jupiter, Europa is a winter lover’s dream. With an icy surface, it’s perfect for a bit of ice skating, curling, hockey, or simple relaxation in your snug wintery cabin.</p>
                                        <hr/>
                                        <div className="destination-info">
                                            <div className="destination-distance">
                                                <p className="info-label">Avg. distance</p>
                                                <p className="info-value">628 mil. km</p>
                                            </div>
                                            <div className="destination-time">
                                                <p className="info-label">Est. travel time</p>
                                                <p className="info-value">3 years</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="titan" className="tab">
                                    <h2 className="destination-title">Titan</h2>
                                        <p className="destination-desc">The only moon known to have a dense atmosphere other than Earth, Titan is a home away from home (just a few hundred degrees colder!). As a bonus, you get striking views of the Rings of Saturn.</p>
                                        <hr/>
                                        <div className="destination-info">
                                            <div className="destination-distance">
                                                <p className="info-label">Avg. distance</p>
                                                <p className="info-value">1.6 bil. km</p>
                                            </div>
                                            <div className="destination-time">
                                                <p className="info-label">Est. travel time</p>
                                                <p className="info-value">7 years</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};
export default Destination;